import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { ViewStates } from '../../enums/day-info-view-states.enum';


export interface WebAppSettingsDto {
  idPerson?: number | null;
  idAdmiaUser?: number | null;
  groupKey: string;
  nameKey: string;

  valueString?: string | null;
  valueInt?: number | null;
  valueBool?: boolean | null;
  valueDateTime?: string | null;
  valueDecimal?: number | null;
}

export interface TaskResult {
  successful: boolean;
  message?: string;
}

export interface SettingsState {
  darkMode: boolean;
  theme: string;
  showOperation: boolean;
  smallScreenWidth: number;
  preferredDayInfoViewState: ViewStates;
  preferredExpenseViewState: ViewStates;
  preferredBookingViewState: ViewStates;
  showBarcodeScanner: boolean;
  showTimeInEdit: boolean;
  showMultiOrder: boolean;
  userLanguage: string;
}

export const createInitialState = (): SettingsState => ({
  darkMode: false,
  theme: 'admia',
  showOperation: true,
  smallScreenWidth: 500,
  preferredDayInfoViewState: ViewStates.Combined,
  preferredExpenseViewState: ViewStates.Combined,
  preferredBookingViewState: ViewStates.Combined,
  showBarcodeScanner: false,
  showMultiOrder: false,
  showTimeInEdit: true,
  userLanguage: ''
});

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'settings' })
export class SettingsStore extends Store<SettingsState> {
  constructor() {
    super(createInitialState());
  }
}
